// This is necessary, so PNGs work and also we have preview images for not ready loaded images.
export class ImageHelper {
    initCompletedListener(image) {
        if (image.complete) {
            this.removeBackgroundImage(image);
        }
        else {
            image.addEventListener('load', () => {
                this.removeBackgroundImage(image);
            });
        }
    }
    removeBackgroundImage(image) {
        image.style.removeProperty('background-image');
        image.style.removeProperty('background-size');
    }
}
export function initImageHelper(selector = 'img[loading=lazy]') {
    const imageHelper = new ImageHelper();
    const images = document.querySelectorAll(selector);
    images.forEach(image => {
        imageHelper.initCompletedListener(image);
    });
}
